import { fmtNumberBR } from "../../utils/formatBrl";

export const StatCardPercentage = ({ icon, title, value, subtitle, percentage }) => (
    <div className="stat-card">
      <div className="stat-card-header">
        <div className={`stat-icon ${icon.color}`}>
          {icon.Icon ? <icon.Icon size={20} strokeWidth={2} /> : <i className={icon.class}></i>}
        </div>
        <div className="stat-title">{title}</div>
      </div>
      <div className="stat-value">{value}</div>
      {subtitle && <div className="stat-change">{subtitle}</div>}
      <div style={{ 
        borderTop: '0.2px solid rgba(148, 163, 184, 0.15)', 
        margin: '15px 0 8px 0' 
      }}></div>
      <div style={{ fontSize: '13px', color: '#94a3b8', marginBottom: '8px' }}>
        Conversão: {percentage?.toFixed(1) || '0.0'}%
      </div>
      <div style={{ 
        width: '100%', 
        height: '4px', 
        backgroundColor: 'rgba(148, 163, 184, 0.1)', 
        borderRadius: '2px',
        overflow: 'hidden'
      }}>
        <div style={{
          width: `${Math.min(percentage || 0, 100)}%`,
          height: '100%',
          background: {
            blue:      'var(--blue)',
            orange:    '#f97316',
            green:     'var(--success)',
            'dark-blue': '#2563eb',
          }[icon.color] ?? 'var(--purple)',
          borderRadius: '2px',
          transition: 'width 0.6s ease-in-out'
        }}></div>
      </div>
    </div>
  );